import { render, staticRenderFns } from "./OsobaDodatneAktivnosti.vue?vue&type=template&id=68a3f485&scoped=true&"
import script from "./OsobaDodatneAktivnosti.vue?vue&type=script&lang=js&"
export * from "./OsobaDodatneAktivnosti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a3f485",
  null
  
)

export default component.exports